import React from "react";
import { Box, MainText, MainTitle } from "app/components/common";
import AnimatedBox from "app/components/common/AnimatedBox";
import { StyleSheet, View } from "react-native";
import theme from "app/Theme/Theme";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

const MARGIN = theme.spacing.sm;
const STEPS_NUMBER = 5;

const styles = StyleSheet.create({
  main: {
    borderWidth: isWebDesktop ? 1 : 2,
    borderColor: isWebDesktop
      ? theme.colors["neutral.100"]
      : theme.colors["neutral.white"],
    borderRadius: 8,
  },
  boxSelected: {
    borderWidth: isWebDesktop ? 2 : 3,
    borderColor: theme.colors["brand.500"],
  },
  sessionBar: {
    height: 5,
    backgroundColor: theme.colors["neutral.100"],
    borderRadius: 25,
  },
  sessionDone: {
    backgroundColor: theme.colors["brand.500"],
  },
});

interface IProps {
  categoryTitle: string;
  experience: string;
  progress: number;
  isSelected: boolean;
  isPlainColor: boolean;
  boxWidth: number;
}

const NextCategoryBox = ({
  categoryTitle,
  experience,
  progress,
  isSelected,
  isPlainColor,
  boxWidth,
}: IProps) => {
  const sessionWidth =
    (boxWidth - theme.spacing.m - (STEPS_NUMBER - 1) * MARGIN) / STEPS_NUMBER;

  return (
    <AnimatedBox style={[styles.main, isSelected && styles.boxSelected]}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
      >
        <Box flex={1} marginRight="sm">
          <MainText
            variant="l5-bold"
            color={isPlainColor ? "neutral.900" : "neutral.400"}
          >
            {categoryTitle}
            {isSelected && (
              <MainText
                variant="l4-semibold"
                color="brand.500"
                marginLeft="xxs"
              >{` (+1)`}</MainText>
            )}
          </MainText>
        </Box>
        <MainTitle
          variant="l4-bold"
          color={isPlainColor ? "neutral.900" : "neutral.400"}
        >
          {experience}
          <MainText
            variant="l2-semibold"
            color={isPlainColor ? "neutral.900" : "neutral.400"}
          >
            /5
          </MainText>
        </MainTitle>
      </Box>
      <Box
        marginTop="m"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
      >
        {Array.apply(null, Array(STEPS_NUMBER)).map((el, index) => {
          const isDone = index + 1 <= progress * 10;
          return (
            <View
              key={index}
              style={[
                styles.sessionBar,
                { width: sessionWidth },
                isDone && styles.sessionDone,
              ]}
            />
          );
        })}
      </Box>
    </AnimatedBox>
  );
};

export default NextCategoryBox;
